const commonBenefits = [
  '사업과 실적부터 차트 및 최종 의견까지 확인합니다.',
  '보고서와 함께 소장한 캐릭터 카드는 보관함에 남습니다.',
];

export const bitePlanOfferings = [
  { id: 'card' as const, name: '30크레딧 충전', description: '필요한 만큼 충전해서 분석하세요.', period: '한 번 결제', benefits: ['보고서 한 건을 30크레딧으로 소장합니다.', '최신 자료로 갱신할 때 20크레딧을 사용합니다.', '충전한 크레딧은 월 초기화 없이 유지됩니다.', ...commonBenefits] },
  { id: 'monthly' as const, name: '월간 패스', description: '매월 300크레딧으로 관심 기업을 분석하세요.', period: '매월 결제', benefits: ['매월 300크레딧이 지급됩니다.', '진입가와 목표가, 익절가, 손절가를 확인합니다.', '보고서 한 건은 30크레딧, 갱신은 20크레딧입니다.', '남은 구독 크레딧은 매월 초기화됩니다.', ...commonBenefits] },
];
export type BitePlanId = 'card' | 'monthly';
export const bitePurchasePlan = (value: string | null): BitePlanId | null =>
  value === 'card' || value === 'monthly' ? value : null;
export const bitePurchaseHref = (plan: BitePlanId, ticker?: string) =>
  ticker ? `/bite/${encodeURIComponent(ticker)}?purchase=${plan}` : `/bite?purchase=${plan}#bite-search`;
